import { defineComponent as n, openBlock as t, createBlock as r, unref as i, withCtx as o, resolveDynamicComponent as a, normalizeClass as c, renderSlot as s } from "vue";
import m from "./ghl-ui.es171.js";
import "./ghl-ui.es61.js";
import f from "./ghl-ui.es87.js";
const g = n({
  name: "UIFormLabelTooltip",
  inheritAttrs: !1
}), p = n({
  ...g,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: m
    },
    iconClass: String
  },
  setup(e) {
    return (l, u) => (t(), r(i(f), {
      placement: e.placement,
      trigger: e.trigger
    }, {
      trigger: o(() => [
        (t(), r(a(e.icon), {
          class: c(e.iconClass ? e.iconClass : "w-4 h-4 text-gray-500")
        }, null, 8, ["class"]))
      ]),
      default: o(() => [
        s(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger"]));
  }
}), S = p;
export {
  S as default
};
